import { Button, Col, Divider, Form, Row, Avatar, Typography, Pagination, Modal, notification, Spin, Empty } from 'antd';
import React, { useEffect, useRef, useState } from 'react'
import ModalForm from './ModalForm';
import { notificationService } from '../../../services';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import { ROLES } from '../../../constants';
import { FaCircle } from "react-icons/fa";
import { updateDoc, getDoc, doc } from "firebase/firestore";
import { db } from "../../../firebase/config";
import { useSelector } from 'react-redux';
import NotificationDetail from '../../../components/NotificationDetail';
import { CiCircleCheck } from "react-icons/ci";
import { IoMdNotifications } from 'react-icons/io';
import { LuBell } from "react-icons/lu";
import { GoDotFill } from "react-icons/go";

dayjs.extend(relativeTime)

export const resetNotificationCount = async (userId) => {
    const ref = doc(db, "notification_counts", userId);
    const snap = await getDoc(ref);

    if (snap.exists()) {
        const currentCount = snap.data().count || 0;
        const newCount = currentCount > 0 ? currentCount - 1 : 0;

        await updateDoc(ref, { count: newCount });
    }
};

function Notification() {

    const [form] = Form.useForm();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [detailModal, setDetailModal] = useState(false)
    const [loading, setLoading] = useState(false)
    const [notifications, setNotifications] = useState([])
    const [pagination, setPagination] = useState({
        current: 1,
        total: 0,
        pageSize: 10,
    })
    const [data, setData] = useState([])
    const [filterType, setFilterType] = useState(""); // "", "0", "1"

    const [selectedNotification, setSelectedNotification] = useState(null);
    const role = localStorage.getItem("role")
    const user = JSON.parse(localStorage.getItem("user"))

    const count = useSelector((state) => state.notification.count);
    const [unreadCount, setUnreadCount] = useState(0)
    const prevCountRef = useRef(count);
    const hasMountedRef = useRef(false);

    const handleOpen = (item) => {
        setSelectedNotification(item);
        setDetailModal(true);
        if (item.is_read === 0) {
            resetNotificationCount(String(user.id))
            if (role !== ROLES.ADMIN) {
                const response = notificationService.read(item.id);
                if (response?.success) {
                    notification.error({
                        message: "Error reading the notification."
                    })
                }
            }
            setUnreadCount((prev) => Math.max(prev - 1, 0));

        }
    };

    const handleClose = () => {
        setIsModalOpen(false);
        setDetailModal(false)
        setSelectedNotification(null);
        setNotifications(prev =>
            prev.map(notification =>
                notification.id === selectedNotification.id
                    ? { ...notification, is_read: 1 }
                    : notification
            )
        );
    };

    const showModal = () => setIsModalOpen(true);

    const handleCancel = () => {
        setIsModalOpen(false);
        form.resetFields();
    };

    const initialize = async (page = 1, pageSize = pagination.pageSize, is_read = "") => {
        setLoading(true);
        const { success, data } = await notificationService.fetch(page, pageSize, is_read);
        setLoading(false);
        if (success) {
            setData(data)
            setNotifications(data?.notifications?.data || []);
            setPagination((prev) => ({
                ...prev,
                total: data?.notifications?.total,
                current: page,
                pageSize,
            }));
            setUnreadCount(data?.unread_count || 0); // 👈 update here
        }
    };


    useEffect(() => {
        if (!hasMountedRef.current) {
            initialize();
            hasMountedRef.current = true;
        } else if (prevCountRef.current !== null && count > prevCountRef.current) {
            initialize();
        }

        prevCountRef.current = count;
    }, [count])

    return (
        <>
            <h4 className='mt-5 mb-0 pb-3 text-[6px] font-normal uppercase flex items-center gap-2'><span><GoDotFill style={{ color: "#B83D3D" }} /></span>Notifications</h4>
            <div
                style={{
                    padding: "12px",
                    borderRadius: "8px",
                    backgroundColor: "#FFFFFF",
                    width:"100%"
                }}
            >
                <div className=' flex pl-2 pt-3  w-full'>
                {/* <h4 style={{ fontWeight: "bold" }} className="flex items-center gap-1">
                        <span>
                            <LuBell
                                style={{ fontSize: 20, color: "red", cursor: "pointer" }}
                            />
                        </span>
                        Notifications
                    </h4> */}
                <div className='flex justify-between items-center w-full'>
                    <p className='text-sm'>
                        Unread{" "}
                        <span className='inline-flex items-center justify-center w-7 h-7 bg-primary text-white rounded-full text-sm font-medium'>
                            {unreadCount}
                        </span>
                    </p>
                    {role === ROLES.ADMIN &&
                        <div className="pr-2 pt-2">
                            <Button type='primary' onClick={showModal}> Add Notification</Button>
                        </div>
                    }
                </div>
                    </div>

                <div className='flex gap-2 mx-2 m-4'>
                    <Button
                        className='rounded-2xl'
                        type={filterType === "" ? "primary" : "default"}
                        onClick={() => {
                            setFilterType("");
                            initialize(1, pagination.pageSize, "");
                        }}
                    >
                        All
                    </Button>

                    <Button
                        className='rounded-2xl'
                        type={filterType === "0" ? "primary" : "default"}
                        onClick={() => {
                            setFilterType("0");
                            initialize(1, pagination.pageSize, "0"); // unread = 0
                        }}
                    >
                        Unread
                    </Button>

                    <Button
                        className='rounded-2xl'
                        type={filterType === "1" ? "primary" : "default"}
                        onClick={() => {
                            setFilterType("1");
                            initialize(1, pagination.pageSize, "1"); // read = 1
                        }}
                    >
                        Read
                    </Button>
                </div>


                {loading ?
                    <div className="flex justify-center min-w-full min-h-[50vh] items-center">
                        <Spin spinning={loading} size={"large"} tip="Loading..." />
                    </div>
                    :
                    (notifications?.length > 0) ?
                        <>
                            <Row>
                                <Col span={24}>
                                    {notifications.map((item, index) => {
                                        const duration = dayjs(item?.created_at).format("DD MMM YYYY, h:mm A");
                                        return (
                                            <div
                                                key={index}
                                                onClick={() => handleOpen(item)}
                                                className={`notification-card ${item?.is_read === 0 ? "unread" : "read"
                                                    }`}
                                                // style={{
                                                //     margin: "0px 15px 15px 15px",
                                                //     padding: 15,
                                                //     backgroundColor: item?.is_read === 0 ? "white" : "#F3F4F6",
                                                //     boxShadow: " ",
                                                //     position: 'relative',
                                                //     border: "1px solid #E2E8F0",
                                                //     borderLeft: item?.is_read === 0 ? "6px solid red" : "1px solid #E2E8F0",
                                                //     borderRadius: 10,
                                                //     transition: "background-color 0.3s",
                                                //     cursor: "pointer",
                                                // }}
                                                onMouseEnter={(e) => {
                                                    e.currentTarget.style.backgroundColor = "white";
                                                }}
                                                onMouseLeave={(e) => {
                                                    e.currentTarget.style.backgroundColor = "#FBFBFB";
                                                }}
                                            >
                                                {(role !== ROLES.ADMIN && item?.is_read === 0) && <FaCircle
                                                    style={{
                                                        position: 'absolute',
                                                        top: 50,
                                                        right: 20,
                                                        fontSize: 12,
                                                        cursor: 'pointer',
                                                        color: "#B83D3D",
                                                        animation: 'pulse 1.5s infinite',
                                                    }}
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                    }}
                                                />}

                                                <div className='flex flex-col justify-start '>
                                                    <div className='flex justify-between'>
                                                        <div className='flex items-center'>
                                                            <GoDotFill style={{ color: "red" }} />
                                                            <Typography.Title level={4} style={{ marginBottom: 4 }}>{item?.subject}</Typography.Title>
                                                        </div>
                                                        {item?.is_read === 1 ?
                                                            <CiCircleCheck style={{ fontSize: 26, color: '#00C951' }} /> : null
                                                        }
                                                    </div>
                                                    <p style={{
                                                        fontSize: 14,
                                                        whiteSpace: 'nowrap',
                                                        overflow: 'hidden',
                                                        textOverflow: 'ellipsis',
                                                        marginBottom: 4,
                                                        color: "#4A5565",
                                                        fontWeight: "normal"
                                                    }}>
                                                        {item?.message}
                                                    </p>

                                                    <p style={{ margin: 0, color: "#6A7282", fontWeight: "lighter", fontSize: 12, }}>{duration} {" "} {item?.id === 1 && "[Sent By Admin]"}</p>
                                                </div>
                                            </div>

                                        )
                                    })
                                    }
                                </Col>
                            </Row>
                            <Row style={{ marginTop: 20 }}>
                                <Col span={24} style={{ display: 'flex', justifyContent: "right" }}>
                                    <Pagination current={pagination.current} total={pagination.total} onChange={(number) => { initialize(number) }} />
                                </Col>
                            </Row>
                        </>
                        :
                        <Empty style={{ paddingBottom: 20 }} />
                }

                <style>
                    {
                        `
                    .notification-card {
  margin: 0px 15px 15px 15px;
  padding: 15px;
  position: relative;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  background-color: #ffffff;
  cursor: pointer;
  transition: all 0.3s ease;
}

/* Unread: red border and white background */
.notification-card.unread {
  border-left: 6px solid red;
  background-color: #ffffff;
}

/* Read: gray tone */
.notification-card.read {
  border-left: 1px solid #e2e8f0;
  background-color: #f3f4f6;
}

/* ✨ Hover effect */
.notification-card:hover {
  background-color: #f9fafb;
  transform: translateY(-3px);
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.08);
}

        `
                    }
                </style>

                <NotificationDetail detailModal={detailModal} selectedNotification={selectedNotification} handleClose={handleClose} />

                <ModalForm form={form} isAdmin={true} handleCancel={handleCancel} isModalOpen={isModalOpen} setNotifications={setNotifications} />
            </div>
        </>


    )
}

export default Notification
